import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import AddressPicker from '../../common/components/address-picker'
import Recaptcha from '../../common/components/recaptcha'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import CurrentProgress from '../../common/components/current-progress'
import Container from '../../common/components/container'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import QueryString from 'query-string'
import { getQueryString } from '../../common/util'
import checkedOptions from '../../common/options/check-options'
import yesNoOptions from '../../common/options/yes-no-options'
import QuoteNumber from '../../common/components/quote-number'

import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withProductData } from '../../common/modules/product-data';
import { withAddressValidation } from '../../common/modules/address-validation';
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config';
import { withErrors } from '../../common/modules/errors'


export const formConfig = state => {
    const fields = state.fields
    const productData = state.productData
    const addressValidation = state.addressValidation

    const manualAddress = !!state.fields.addressNotFound /* || state.fields.__firstAddressAsk__*/
    
    return {
        rules: {
            currentInsurer: [
                Validation.enforce.required("Please select your current insurer"),
            ],
            otherInsurer: [
                Validation.enforce.required("Name of your current insurer"),
            ],
            insuredName: [
                Validation.enforce.required("Please provide the name to use on the Landlord Contents Policy"),
            ],
            startDate: [
                Validation.enforce.required("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
                Validation.enforce.date("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
            ],
            numberOfClaims: [
                Validation.enforce.required("Please select number of claims")
            ],
            valueOfClaims: [
                Validation.enforce.required("Please enter the amount you claimed"),
                Validation.enforce.number("The amount must be a whole dollar value"),    
            ],
            propertyInsuranceDeclined: [
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            coverLimited: [
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            addressNotFound: [],
            streetAddress: !manualAddress ? [ Validation.enforce.required("Please enter a street address") ] : [],
            unitNumber: !manualAddress ? [] : [],
            streetNumber: !manualAddress ? [] :[
                Validation.enforce.required("Please provide the street number"),
            ],
            streetName: !manualAddress ? [] :[
                Validation.enforce.required("Please provide the street name"),
            ],
            suburb: !manualAddress ? [] :[
                Validation.enforce.required("Please provide the suburb"),
            ],
            postcode: [
                Validation.enforce.required("Please provide the postcode"),
            ],
            state: !manualAddress ? [] :[
                Validation.enforce.required("Please provide the state"),
            ],
        },

        options:{
            currentInsurer: productData.productOptions.INSURER,
            numberOfClaims:[
                { label: "0", value:0 },
                { label: "1", value:1 },
                { label: "2", value:2 },
                { label: "3", value:3 },
                { label: "4", value:4 },
                { label: "5+", value:5 },
            ],
            state:[
                { label:'NSW', value: 'NSW' },
                { label:'VIC', value: 'VIC' },
                { label:'QLD', value: 'QLD' },
                { label:'WA', value: 'WA' },
                { label:'ACT', value: 'ACT' },
                { label:'NT', value: 'NT' },
                { label:'TAS', value: 'TAS' },
            ],
            propertyInsuranceDeclined: yesNoOptions,
            coverLimited: yesNoOptions
        },

        predicates:{
            valueOfClaims: fields.numberOfClaims != 0 && fields.numberOfClaims != undefined,
            otherInsurer: fields.currentInsurer === "OTHER"
        },
        inferred:{},
        
        transformOut: data => ({
            ...data,
        })

    }

}

@withErrors
@withSubmission
@withNavigation
@withValidation
@withProductData
@withAddressValidation
@withRouteBlocker
@withScrollToTop
@withConfig
@withForm(formConfig)
export default class extends React.Component<any, any> {
   
    componentWillMount(){
        const fields = this.props.fields;
        let fullName = fields.firstName + " " + fields.surname;
        this.props.actions.fields.updateField("insuredName", fullName);
    }
    

    render() {
        const fields = this.props.fields;
        const addressNotFound = fields.addressNotFound

        return ( 
            <div className="row">
                <StepTitle>Tell Us About Your Current Insurance</StepTitle>	
                <QuoteNumber />
                
                <InputField field="insuredName"                     label="What name would you like the policy to be in?"  /> 
                <InputField field="currentInsurer"                  label="Who is your current contents Insurance with?"   />
                <InputField field="otherInsurer"                    label="Specify other insurer" />
                <InputField field="startDate"                       label="When do you want your cover to start?"        endDate='+90d'       type="Date"        description="This will be used as the start date of your new policy."/>
                    
                <SubHeader>Your Duty of Disclosure</SubHeader>
                <InputField field="numberOfClaims"                  label="How many claims have you had in the past five (5) years?"                      inline />
                <InputField field="valueOfClaims"                   label="Value of claims"                                            type="Currency"    inline />
                <InputField field="propertyInsuranceDeclined"       label="Has insurance on this property been declined in the past five (5) years?" />
                <InputField field="coverLimited"                    label="Has the cover under your current policy been limited or restricted in any way?" />
                
                <SubHeader id="address-scroll-point">Tell us where you want to insure</SubHeader>

                { !addressNotFound && <InputField field="postcode"      label="Postcode"        size="col-md-3"  type="number" /> }
                { !addressNotFound && <InputField field="streetAddress" label="Street address"  size="col-md-8"  addressNotFoundField="addressNotFound" type="PostcodeAuto" postcodeField="postcode" unitField="unitNumber" streetNumberField="streetNumber" streetNameField="streetName" suburbField="suburb" stateField="state"/> }
                
                {this.props.fields.addressNotFound || !this.props.fields.quoteNumber && <SubHeader>Sorry we couldn't find your address, please enter it manually:</SubHeader> }
                { addressNotFound && <InputField field="unitNumber"    label="Unit/Lot/Suite"  size="col-md-3"   placeholder="Optional"/> }
                { addressNotFound && <InputField field="streetNumber"  label="Street number"   size="col-md-3" /> }
                { addressNotFound && <InputField field="streetName"    label="Street name"     size="col-md-6" /> }
                { addressNotFound && <InputField field="suburb"        label="Suburb/Town"     size="col-md-6" /> }
                { addressNotFound && <InputField field="state"         label="State"           size="col-md-3" /> }
                { addressNotFound && <InputField field="postcode"      label="Postcode"        size="col-md-3" type="number"/> }

                {/*
                <SubHeader>Tell us where you want to insure</SubHeader>
                <InputField field="unitNumber"                            label="Unit/Lot/Suite"  size="col-md-3"   placeholder="Optional" />
                <InputField field="streetNumber"                    label="Street number"   size="col-md-3"   />
                <InputField field="streetName"                      label="Street name"     size="col-md-6"   />
                <InputField field="suburb"                          label="Suburb/Town"     size="col-md-6"   type="SuburbAuto"  stateField="state" postcodeField="postcode"/>
                <InputField field="state"                           label="State"           size="col-md-3"   enabled={false} />
                <InputField field="postcode"                        label="Postcode"        size="col-md-3"   enabled={false} />
                */}

                <Button.Container>
                    <Button.Back route="/step-1" />
                    <Button.Continue onClick={ this.validate.bind(this) } />
                </Button.Container>
            </div>
        )
    }



    addStreetAddressErrors(){
        this.props.actions.errors.setErrors({
            ...this.props.errors,
            streetAddress: ["Please select an option"]
        })
    }


    validate(){
        const fields = this.props.fields;
        if(!fields.addressNotFound && (!fields.streetNumber || !fields.streetName || !fields.suburb || !fields.state || !fields.postcode)){    
            this.props.actions.validation.validate(this.addStreetAddressErrors.bind(this));
        }else{
            this.props.actions.validation.validate( this.submit.bind(this) );
        }
    }



    submit(){
        const endpoint = this.props.submission.endpoints.step2
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            formConfig
        ] );
    }


    proceed(){
        const config = this.props.config;
        
        window["dataLayer"].push({
            'event' : 'gaEvent' ,
            'eventCategory' : 'quote forms' ,
            'eventAction' : config.project + ' quote created' , // Type of quote created
            'eventLabel' : this.props.fields.quoteNumber , // Quote number created
            'eventValue' : null ,
            'eventNonInteraction' : true
    });

        this.props.actions.navigation.changeRoute("/step-3")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-2.tsx